<dx-popup
    #manageTaskPopup
    minWidth="150px"
    minHeight="150px"
    width="60%"
    height="75%"
    [title]="manageWorkOrderTaskTitle"
    [showTitle]="true"
    [showCloseButton]="true"
    [shading]="false"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [(visible)]="visible"
    (onShown)="onPopupShown()"
    (onHidden)="onPopupClose()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <dx-tabs
                        width="50%"
                        keyExpr="key"
                        class="cc-tabs"
                        itemTemplate="tabTemplate"
                        [dataSource]="tabItems"
                        [(selectedItem)]="selectedTabItem"
                    >
                        <div *dxTemplate="let d of 'tabTemplate'">
                            {{ d.displayText }}
                        </div>
                    </dx-tabs>
                </div>
            </dxi-item>
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <div *ngIf="selectedTabItem.key === 'openTasks'" class="full-width full-height">
                        <app-manage-open-tasks
                            #openTasks
                            [taskIds]="taskIds"
                            [communityId]="communityId"
                            [workOrderId]="workOrderId"
                        ></app-manage-open-tasks>
                    </div>
                    <div *ngIf="selectedTabItem.key === 'closedTasks'" class="full-width full-height">
                        <app-manage-closed-tasks
                            #closedTasks
                            [taskIds]="taskIds"
                            [workOrderId]="workOrderId"
                            [communityId]="communityId"
                        ></app-manage-closed-tasks>
                    </div>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate class="toolbar-container">
                    <dx-toolbar width="100%">
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Close"
                                    hint="Close"
                                    [icon]="iconClose"
                                    (onClick)="onCloseClick()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button
                                    type="success"
                                    text="Save"
                                    hint="Save"
                                    [icon]="iconSave"
                                    (onClick)="onSaveClick()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>
